import { NavigationTabs } from "../components/navigation";
import {
    ServiceTermsSetupPage,
    ServiceTermsDetailedPage
} from "../pages/management-client-serviceterms";
import ClientServiceTermsManagementLayout from "../layouts/ClientServiceTermsManagementLayout";

const ManagementServiceTermsRoutes = {
    path: 'slas',
    pathBase: '/management/slas',
    defaultRoute: "service-terms",
    roles: [],
    element: ClientServiceTermsManagementLayout,
    children: [
        { 
            path: 'service-terms', 
            icon: 'fa-file-signature', 
            label: 'Client Service Terms', 
            roles: [],
            element: ServiceTermsDetailedPage
        },
        { 
            path: 'setup', 
            icon: 'fa-cog', 
            label: 'Set up', 
            roles: [],
            element: ServiceTermsSetupPage
        },
        
        
    ]
};

export const ManagementServiceTermsRouteTabs = () => <NavigationTabs pathBase={ManagementServiceTermsRoutes.pathBase} options={ManagementServiceTermsRoutes} />

export default ManagementServiceTermsRoutes;